import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const CenterCenter: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default CenterCenter;
